<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :icons="icon_data"
            :load_url="load_url"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'TodaysAppraisalStatusTotal',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            return {
                main_icon: 'fa-light fa-box-full',
                title: 'Total Appraisal - (MTD)',
                load_url: '/dashboards/TotalAppraisal/',
                time_wait: 10000,
                icon_data: [
                    {
                        // Green
//                        name: 'Total Orders to Process',
                        name: 'Orders to Process',
                        text_color: '#2A9D8F',
                    },
                    {
                        // dark blue
//                        name: 'Total Orders Processed',
                        name: 'Orders Processed',
                        text_color: '#264653',
                    },
                    {
                        //orange
//                        name: 'Total Pieces Processed',
                        name: 'Pieces Processed',
                        text_color: '#F4A261',
                    },
                    {
                        // red
//                        name: 'Total Items Processed',
                        name: 'Items Processed',
                        text_color: '#E76F51',
                    },
                    {
                        //yellow
//                        name: 'Total Orders on Hold',
                        name: 'Orders on Hold',
                        text_color: '#E9C46A',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>